import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * The one-time code: one wide, tabular field (one paste, one autofill).
 */
export function CodeField(props: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={props.id}>{t("totp.code")}</Label>
      <Input
        id={props.id}
        name="code"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9 ]{6,7}"
        maxLength={7}
        required
        autoFocus={props.autoFocus ?? true}
        // Read-only rather than disabled while a code is checked: a disabled field drops focus,
        // and a refused code should be retyped where the person already is.
        readOnly={props.disabled}
        aria-disabled={props.disabled ? true : undefined}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        aria-invalid={props.invalid ? true : undefined}
        placeholder="000 000"
        className="h-12 text-center text-xl font-medium tracking-[0.3em] tabular-nums placeholder:text-fg-muted/50 aria-disabled:opacity-50"
      />
    </div>
  );
}
